import app from './app';
import common from './common';
import drawer from './drawer';
import editor from './editor';
import font from './font';
import gethelp from './gethelp';
import iframe from './iframe';
import loader from './loader';
import navbar from './navbar';
import page from './page';
import wrapper from './wrapper';
import { sidebarStore } from '@modules/editor-sidebar';
import product from './product';

const modules = {
  app,
  common,
  drawer,
  editor,
  font,
  gethelp,
  iframe,
  loader,
  navbar,
  page,
  sidebar: sidebarStore,
  wrapper,
  product,
};
export default modules;
